"use client";

import React, { type ReactElement, useEffect } from "react";
import { useSearchParams } from "next/navigation";
import {
  SitesMovablePanelList,
  SitesMap,
  SitesControlBottom,
  SitesSidebar,
  BlurryEffect,
} from "@/components";
import { useAtomValue, useSetAtom } from "jotai";
import {
  selectedTagIdsAtom,
  observatoriesAtom,
  selectedObservatoryAtom,
  setSingThemeVisibilityAtom,
} from "@/store/sites";
import { useObservatories } from "@/hooks/sites";
import { ThemeTypeEnum } from "@/types";

function SitesMain(): ReactElement {
  const observatories = useAtomValue(observatoriesAtom);
  const setSelectedObservatory = useSetAtom(selectedObservatoryAtom);
  const setSelectedTagIds = useSetAtom(selectedTagIdsAtom);
  const setSingleThemeVisibility = useSetAtom(setSingThemeVisibilityAtom);

  const { findObservatoryById } = useObservatories(observatories);
  const searchParams = useSearchParams();

  const deviceParam = searchParams.get("monitoring");
  const tagParam = searchParams.get("tag");
  const themeParam = searchParams.get("theme");

  useEffect(() => {
    if (deviceParam) {
      const observatory = findObservatoryById(deviceParam);
      setSelectedObservatory(observatory);
    }
    if (tagParam) {
      setSelectedTagIds([Number(tagParam)]);
    }
    if (themeParam) {
      setSingleThemeVisibility(themeParam as ThemeTypeEnum);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative h-[calc(100svh-var(--globalnav-height))]">
      <div className="absolute inset-0 bottom-39 bg-accent">
        <SitesSidebar />
        <SitesMap />
        <SitesMovablePanelList />
      </div>
      <SitesControlBottom />
      <figure className="absolute inset-0 z-0 pointer-events-none">
        <BlurryEffect />
      </figure>
    </div>
  );
}

export { SitesMain };
